var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { colors } from "@wrstudios/theme";
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  font-size: 1.4rem;\n  line-height: 2.9rem;\n  padding: 0 1.6rem;\n  color: ", ";\n  white-space: nowrap;\n"], ["\n  width: 100%;\n  font-size: 1.4rem;\n  line-height: 2.9rem;\n  padding: 0 1.6rem;\n  color: ", ";\n  white-space: nowrap;\n"])), colors.gray[600]);
var templateObject_1;
